<template>
    <div>
        <page-header :title="title" :breadcrumbs="breadcrumbs" />

        <div class="row">
            <div
                v-for="(tag, index) in settings"
                :key="index"
                class="col-sm-12 col-md-6 col-xl-4 pb-3"
            >
                <single-tag :tag="tag" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import SingleTag from '@/components/settings/SingleTag';

export default {
    page: {
        title: 'Settings'
    },

    components: {
        SingleTag
    },

    data() {
        return {
            title: 'Settings',
            breadcrumbs: [
                {
                    text: 'Cancer',
                    to: '/'
                },
                {
                    text: 'Settings',
                    active: true
                }
            ],
            settings: {}
        };
    },

    async created() {
        try {
            const parsedSettings = {};
            let settings = await this.getSettings();
            settings = settings.sort((a, b) => (a.tag > b.tag ? 1 : -1));

            settings.map(setting => {
                if (!parsedSettings[setting.tag]) {
                    parsedSettings[setting.tag] = [];
                }

                parsedSettings[setting.tag] = [
                    ...parsedSettings[setting.tag],
                    setting
                ];
            });

            this.settings = { ...parsedSettings };
        } catch (err) {
            console.error(err);
        }
    },

    methods: {
        ...mapActions({
            getSettings: 'settings/index'
        })
    }
};
</script>
